var _defs, _circle, _path, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eye_svg__a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".eye_svg__b{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "eye_svg__b",
    cx: 100,
    cy: 100,
    r: 21.35
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "eye_svg__b",
    d: "M31.21 100C45.16 75.09 71.44 59.67 100 59.67s54.84 15.42 68.79 40.33c-13.95 24.91-40.23 40.33-68.79 40.33S45.16 124.91 31.21 100z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "eye_svg__b",
    cx: 100,
    cy: 100,
    r: 94.51
  })));
}
export default SvgEye;